module.exports = __webpack_public_path__ + "static/media/bg-8.469ccc14.jpg";